export const TAX_CA = {
	AB: {
		name: 'Alberta',
		taxes: [
			{
				code: 'GST',
				name: 'Goods and Services Tax',
				type: 'federal',
				tax: 0.05
			}
		]
	},
	BC: {
		name: 'British Columbia',
		taxes: [
			{
				code: 'GST',
				name: 'Goods and Services Tax',
				type: 'federal',
				tax: 0.05
			}
		]
	},
	MB: {
		name: 'Manitoba',
		taxes: [
			{
				code: 'GST',
				name: 'Goods and Services Tax',
				type: 'federal',
				tax: 0.05
			}
		]
	},
	NB: {
		name: 'New Brunswick',
		taxes: [
			{
				code: 'HST',
				name: 'Harmonized Sales Tax',
				type: 'harmonized',
				tax: 0.15
			}
		]
	},
	NL: {
		name: 'Newfoundland and Labrador',
		taxes: [
			{
				code: 'HST',
				name: 'Harmonized Sales Tax',
				type: 'harmonized',
				tax: 0.15
			}
		]
	},
	NS: {
		name: 'Nova Scotia',
		taxes: [
			{
				code: 'HST',
				name: 'Harmonized Sales Tax',
				type: 'harmonized',
				tax: 0.15
			}
		]
	},
	NT: {
		name: 'Northwest Territories',
		taxes: [
			{
				code: 'GST',
				name: 'Goods and Services Tax',
				type: 'federal',
				tax: 0.05
			}
		]
	},
	NU: {
		name: 'Nunavut',
		taxes: [
			{
				code: 'GST',
				name: 'Goods and Services Tax',
				type: 'federal',
				tax: 0.05
			}
		]
	},
	ON: {
		name: 'Ontario',
		taxes: [
			{
				code: 'HST',
				name: 'Harmonized Sales Tax',
				type: 'harmonized',
				tax: 0.13
			}
		]
	},
	PE: {
		name: 'Prince Edward Island',
		taxes: [
			{
				code: 'HST',
				name: 'Harmonized Sales Tax',
				type: 'harmonized',
				tax: 0.15
			}
		]
	},
	QC: {
		name: 'Québec',
		taxes: [
			{
				code: 'GST',
				name: 'Goods and Services Tax',
				type: 'federal',
				tax: 0.05
			}
		]
	},
	SK: {
		name: 'Saskatchewan',
		taxes: [
			{
				code: 'GST',
				name: 'Goods and Services Tax',
				type: 'federal',
				tax: 0.05
			}
		]
	},
	YT: {
		name: 'Yukon',
		taxes: [
			{
				code: 'GST',
				name: 'Goods and Services Tax',
				type: 'federal',
				tax: 0.05
			}
		]
	}
}
